import React, { useState } from "react";
import Button from "../../Button";
import apiInstance from "../../apiInstance";

const RequestWebsite = ({ closePopup, updateError }) => {

    const [requestData, setRequestData] = useState({
        siteName: "",
        description: ""
    });
    const [fieldErrors, setFieldErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setRequestData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async () => {
        
        setLoading(true);
        updateError("");
        setFieldErrors({});

        try {
            const res = await apiInstance.post(`/dashboard/website/request`, requestData);
            closePopup();
        } catch (error) {
            console.error(`Error:`, error);
            if (error.response) {
                if (
                    error.response.status === 400 &&
                    error.response.data.fieldErrors
                ) {
                    setFieldErrors(error.response.data.fieldErrors);
                } else {
                    updateError(error.response.data.message || 'Something went wrong, please try again later.');
                }
            } 
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="mjs-pp">
            <h2>Request New Website</h2>
            <form>

                <div className="mjs-input-field">
                    <label htmlFor="siteName">Site Name</label>
                    <input
                        type="text"
                        placeholder="Site name"
                        name="siteName"
                        value={requestData.siteName}
                        onChange={handleInputChange}
                    />
                    {fieldErrors.siteName && (
                        <span className="mjs-error">
                            {fieldErrors.siteName}
                        </span>
                    )}
                </div>

                <div className="mjs-input-field">
                    <label htmlFor="description">Description</label>
                    <textarea
                        name="description"
                        value={requestData.description}
                        onChange={handleInputChange}
                    >
                        {requestData.description}
                    </textarea>
                    {fieldErrors.description && (
                        <span className="mjs-error">
                            {fieldErrors.description}
                        </span>
                    )}
                </div>

            </form>

            <div className="mjs-form-actions">
                {loading && (
                    <i
                        className="fa-solid fa-spinner fa-spin"
                    ></i>
                )}
                <Button
                    name="Request"
                    eventHandler={handleSubmit}
                />
                <Button name="Cancel" eventHandler={closePopup} />
            </div>
        </div>
    );
};

export default RequestWebsite;
